import { fetchPublicApi } from '@/lib/api/apiServiceBase.ts';
import {
  SettingApprovalPreviewDto,
  SettingApprovalResponseDto,
} from '@/features/public/settingApproval/types/SettingApprovalDto.ts';

const settingApprovalApi = {
  getPreview: (token: string) =>
    fetchPublicApi<SettingApprovalPreviewDto>(
      'GET',
      `public/setting-approvals?token=${encodeURIComponent(token)}`,
    ),
  approve: (token: string) =>
    fetchPublicApi<SettingApprovalResponseDto>(
      'POST',
      'public/setting-approvals',
      { token },
    ),
};

export default settingApprovalApi;
